/*global google*/
import React, { Component } from "react";
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  DirectionsRenderer,
  Marker,
} from "react-google-maps";
import {
  addressARedIcon,
  addressBRedIcon,
  addressCRedIcon,
  trackingTruckImage,
  userIconImage,
} from "../../../assets";

const positionA = { lat: 40.756795, lng: -73.954298 };
class Map extends Component {
  state = {
    directions: null,
    directions2: null,
    currentPosition: {
      lat: this.props.address[0].latitude,
      lng: this.props.address[0].longitude,
    },
  };

  componentDidMount() {
    console.log("object", this.props.address);
    const { address } = this.props;
    const directionsService = new google.maps.DirectionsService();
    const origin = { lat: address[0].latitude, lng: address[0].longitude };
    const destination = { lat: address[1].latitude, lng: address[1].longitude };

    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result,
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );

    directionsService.route(
      {
        origin: destination,
        destination: { lat: address[2].latitude, lng: address[2].longitude },
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          this.setState({
            ...this.state,
            directions2: result,
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );

    setTimeout(() => {
      this.setState({
        ...this.state,
        currentPosition: {
          lat: this.props.address[1].latitude,
          lng: this.props.address[1].longitude,
        },
      });
    }, 5000);
  }

  render() {
    console.log(this.props, "THIS > PROPS");
    const originIcon = {
      lat: this.props.address[0].latitude,
      lng: this.props.address[0].longitude,
    };

    const destinationIcon = {
      lat: this.props.address[1].latitude,
      lng: this.props.address[1].longitude,
    };

    const GoogleMapExample = withGoogleMap((props) => (
      <GoogleMap
        // defaultCenter={{ lat: 40.756795, lng: -73.954298 }}
        defaultZoom={13}
        zoom={12}
        options={{
          disableDefaultUI: true,
          zoomControl: true,
          fullscreenControl: true,
        }}
        onClick={(e) => {
          console.log([{ lat: e.latLng.lat(), lng: e.latLng.lng() }]);
        }}
      >
        <Marker
          options={{
            icon: {
              url: trackingTruckImage,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
              scaledSize: new window.google.maps.Size(70, 70),
            },
            position: this.state.currentPosition,
            visible: true,
          }}
        />

        <Marker
          options={{
            icon: {
              url: addressARedIcon,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
              // scaledSize: new window.google.maps.Size(50, 50),
            },
            position: originIcon,
            visible: true,
          }}
        />
        <Marker
          options={{
            icon: {
              url: addressBRedIcon,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
              // scaledSize: new window.google.maps.Size(50, 50),
            },

            position: destinationIcon,
            visible: true,
          }}
        />
        <Marker
          options={{
            icon: {
              url: addressCRedIcon,
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
              // scaledSize: new window.google.maps.Size(50, 50),
            },

            position: {
              lat: this.props.address[2].latitude,
              lng: this.props.address[2].longitude,
            },
            visible: true,
          }}
        />
        {this.state.directions && (
          <DirectionsRenderer
            options={{
              suppressMarkers: true,
              // markerOptions: {
              //   icon: addressARedIcon,
              //   position: { lat: 40.756795, lng: -73.954298 },
              // },
            }}
            directions={this.state.directions}
          ></DirectionsRenderer>
        )}
        {this.state.directions2 && (
          <DirectionsRenderer
            options={{
              suppressMarkers: true,
              // markerOptions: {
              //   icon: addressARedIcon,
              //   position: { lat: 40.756795, lng: -73.954298 },
              // },
            }}
            directions={this.state.directions2}
          ></DirectionsRenderer>
        )}
      </GoogleMap>
    ));

    return (
      <div>
        <GoogleMapExample
          containerElement={<div style={{ height: `600px`, width: "100%" }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
    );
  }
}

export default Map;
